// import { StrictMode } from 'react'
// import { createRoot } from 'react-dom/client'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// import App from './App.jsx'
// import Subpage from './subpage.jsx'
// import Footer from './Footer.jsx'

// createRoot(document.getElementById('root')).render(
//   <StrictMode>
//     <Subpage/>
//     <Footer/>
//   </StrictMode>,
// )


import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import Subpage from './NewSubPage';
// import SubFooter from '../Components/SubFooter';
import SubFooter from '../Component/SubFooter';

const SubLandingPage = () => {

    return (
        <>
            <Subpage />
            <SubFooter />

        </>

    );
};

export default SubLandingPage;